import { useDisclosure } from '@/hooks';
import { Button } from 'antd';
import SpedDocumentModal from '../SpedDocumentModal';

export default function SpedDocumentCreateButton() {
  const [opened, action] = useDisclosure();

  return (
    <>
      <Button type="primary" onClick={action.open}>
        Novo documento
      </Button>

      <SpedDocumentModal opened={opened} onClose={action.close} />
    </>
  );
}
